module.exports = __webpack_public_path__ + "static/media/17-speaker_profile.5cde5b75.webp";